export default "__VITE_ASSET__zrVWeD4___"